import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AutomationService } from '../automation.service';
import { STATUS_CODES } from '../../common/constants/defines';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';


@Component({
    selector: 'tdrs-validation',
    templateUrl: './tdrs-validation.component.html',
    styleUrls: ['./tdrs-validation.component.css']
})
export class TDRSValidationComponent implements OnDestroy, OnInit {

    public errorOverLay = null;

    public identifiersPerService: any[] = [];

    constructor(private automationService: AutomationService, private router: Router) { }

    ngOnInit(): void {

        if (this.automationService.identifiersPerService) {

            this.identifiersPerService = cloneDeep(this.automationService.identifiersPerService);

            this.automationService.identifiersPerService = null;

            this.animateToTheOverview();
        }
    }

    validateTdrsSheet(data) {

        this.automationService.registerSpinner.next(true);

        this.identifiersPerService = [];

        this.automationService.validateTdrsSheet(data.file)
            .subscribe((identifiersPerService) => {

                this.automationService.registerSpinner.next(false);

                this.identifiersPerService = identifiersPerService;

                if (identifiersPerService && identifiersPerService.length) {

                    this.animateToTheOverview();

                    this.errorOverLay = {
                        message: 'Your sheet has same Identifier values with the already exist stubs, please check the shown stubs',
                        success: false
                    };
                } else {
                    this.errorOverLay = {
                        message: 'Your sheet seems to be valid, you can start generating TDRS now',
                        success: true
                    };
                }
            }, (error) => {

                this.automationService.registerSpinner.next(false);

                if (error && error.json) {

                    if (error.status === 413) {

                        this.errorOverLay = {
                            message: 'Your file is too big, max size is 10 MB',
                            success: false
                        };

                    } else {

                        this.errorOverLay = {
                            message: error.json().message,
                            success: false
                        };
                    }
                } else {

                    this.errorOverLay = {
                        message: error,
                        success: false
                    };
                }
            });
    }

    animateToTheOverview() {

        setTimeout(() => {

            const elmnt = document.getElementById("stubs-overview");

            elmnt.scrollIntoView({ behavior: 'smooth' });
        }, 500);
    }

    closeOverLay() {

        this.errorOverLay = null;
    }

    ngOnDestroy(): void {

        this.automationService.registerSpinner.next(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/tdrs-validation/tdrs-validation.component.ts